import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';

import modelsComplete from '../db/models.json';


export default function (props) {
	const { t, i18n } = useTranslation("",{lng: props.language});
  	let navigate = useNavigate(); 
	
	const callUrl = (url) => {
		navigate(url);
		window.scrollTo(0, 0);
	};
	
	const models = React.useMemo(() => {
		let f = {};
		f.useAsExpansion = "true";
		const filtered = modelsComplete.cars.filter(item =>
		  Object.entries(f).every(([key, value]) => item[key] === value)
		);
		let newModels = {};
		newModels.cars = filtered;	
		return newModels;		
	}) 	

  	return (
		  	<>		
				<section class="about">	 
					<Grid container style={{paddingTop: "40px"}}>
				    	<Grid item xs={12}>
						<Grid container spacing={2}>
						        		<Grid item xs={2}>
							     	   </Grid>
						        		<Grid item xs={8}>
											<Box sx={{paddingTop: "0px", backgroundColor: "#fff"}}>
												{models.cars.map((model, index) => (
													<>
														{model.onlinestatus == "online" && model.useAsExpansion == "true" ? (
															<>
																{index % 2 == 0 ? 
																	(<>
																		<Grid container style={{paddingTop: "40px"}}>
															        		<Grid item xs={12}>
																	      		<Grid container spacing={2}>
																	        		<Grid item xs={6}>
																	        			<Box sx={{borderRadius: "8px", backgroundColor: "#fff"}}>														        			
																							<img style={{borderRadius: "8px", width: "400px", height: "400px"}} src={model.innerPicture} />
																						</Box>
																		     	   </Grid>
																	        		<Grid item xs={6}>
																	        			<h2>{model.label}</h2>
																	        			<p>{model.expansionText[i18n.language]}</p>
																	        			
																						{modelsComplete.cars.map((car) => (
																								<>
																									{car.onlinestatus == "online" && car.compareable == "true" && car.label == model.label ? (
																					        			<Button aria-label="add to favorites"
																					        					variant="contained"
																					        					sx={{marginRight: "5px"}}
																					        					onClick={e => callUrl("/model/"+ car.url +"/")}>
																					          				{car.producerLabel}
																					        			</Button>
												
																									):(<></>)
																									}
																					        	</>											
																						))}
																	        			
																	        			
																		     	   </Grid>
																	     	   </Grid>
																     	   </Grid>
															     	   </Grid>
																	 </>) : 
																	 (<>
																		<Grid container style={{paddingTop: "40px"}}>
															        		<Grid item xs={12}>
																	      		<Grid container spacing={2}>
																	        		<Grid item xs={6}>
																	        			<h2>{model.label}</h2>
																	        			<p>{model.expansionText[i18n.language]}</p>
																						{modelsComplete.cars.map((car) => (
																								<>
																									{car.onlinestatus == "online" && car.compareable == "true" && car.label == model.label ? (
																					        			<Button aria-label="add to favorites"
																					        					variant="contained"
																					        					sx={{marginRight: "5px"}}
																					        					onClick={e => callUrl("/model/"+ car.url +"/")}>
																					          				{car.producerLabel}
																					        			</Button>
												
																									):(<></>)
																									}
																					        	</>											
																						))}																	        			
																		     	   </Grid>
																	        		<Grid item xs={6}>
																	        			<Box sx={{borderRadius: "8px", backgroundColor: "#fff"}}>
																							<img style={{borderRadius: "8px", width: "400px", height: "400px"}} src={model.innerPicture} />
																						</Box>
																		     	   </Grid>
																	     	   </Grid>
																     	   </Grid>
															     	   </Grid>
																		</>)
																}																
															</>
													):(<></>)
													}
									        	</>											

												))}
	
											</Box>	
							     	   	</Grid>
						        		<Grid item xs={2}>
							     	   </Grid>
						     	   </Grid>
					     	   </Grid>
				     	   	</Grid>					
						
			  	</section>
		  </>
	  )
}